/** Stable-enough client ids for React keys and in-flight stream correlation. */
export function createId(prefix: string): string {
  return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}
